/* global angular */
angular.module('ua5App').
    filter('dateForGoogle', function() {
        return function(text) {
            return text ? String(text).replace(/-/gm, ' ') : '';
        };
    }
);
